import { MIN_WEIGHT, MAX_WEIGHT } from './constants';

export const isWeightValid = weight =>
  Number.isInteger(weight) && weight >= MIN_WEIGHT && weight <= MAX_WEIGHT;
